import { TCheckinWidgetTypes, TCheckinWidgetBox } from 'interface'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

export const isCheckinWidgetEnabled = (state: TCheckinWidgetTypes) =>
  ['ENABLED', 'DAY_7_ENABLED'].includes(state)

export const formatState = (state: TCheckinWidgetTypes) =>
  state.startsWith('DAY_7_') ? (state.replace('DAY_7_', '') as TCheckinWidgetTypes) : state

export const detectBrokenSequence = (checkIns: TCheckinWidgetBox[]): boolean => {
  const todayIndex = checkIns.findIndex((item) => item.content.text.toLowerCase() === 'hoje')

  if (todayIndex <= 0) return false

  const before = checkIns.slice(0, todayIndex)
  const isBeforeInvalid = before.some((item) => formatState(item.content.state) !== 'CHECKED')

  return isBeforeInvalid
}

export const fulLWidth = { width: '100%' }

export const SkeletonDayCards = () =>
  [1, 2, 3, 4, 5, 6, 7].map((item) => (
    <Skeleton
      key={item}
      width="96px"
      height="86px"
      animation="pulse"
      style={{ minWidth: '96px', borderRadius: '8px' }}
    />
  ))
